import React from 'react';
import PropTypes from 'prop-types';
import optionTypes from '../constants/option-types';
import SliderOption from './slider-option';

function DesignOtherStylesOption({ option }) {
  switch (option.type) {
    case optionTypes.SLIDER: {
      return <SliderOption {...option} />;
    }

    default:
      return null;
  }
}

DesignOtherStylesOption.propTypes = {
  option: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.oneOf(Object.values(optionTypes)).isRequired,
    options: PropTypes.array,
    title: PropTypes.string,
  }).isRequired,
};

export default DesignOtherStylesOption;
